<template>
  <v-app>
    <d-header></d-header>
    <d-content></d-content>
    <d-footer></d-footer>
    <d-fab></d-fab>
  </v-app>
</template>

<script>
import DHeader from "./Header";
import DFooter from "./Footer";
import DContent from "./Content";
import DFab from "@/components/floating-action-buttons/Whatsapp";
export default {
  components: {
    DHeader,
    DFooter,
    DContent,
    DFab
  }
};
</script>

<style>
.container {
  padding: 0 !important;
}
</style>

<style lang="scss">
@import "../assets/fonts/intro/stylesheet.css";

h1,
h2,
h3,
h4,
h5,
h6,
p,
div,
input,
optgroup,
select,
textarea {
  font-family: "introheadr-base" !important;
}

p {
  font-size: 1.4rem;
}
h1 {
  font-size: 5rem;
}
h2 {
  font-size: 3.5rem;
}
h3 {
  font-size: 2rem;
}
h4 {
  font-size: 1.5rem;
}
h5 {
  font-size: 1rem;
}
h6 {
  font-size: 0.5rem;
}

// @media only screen and (max-width: 599px) {
//   h3 {
//     font-size: 1em !important;
//   }
// }

// @media only screen and (min-width: 600px) {
//   h3 {
//   }
// }
</style>
